var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v("This is an about page")]),_c('button',{on:{"click":_vm.getValue}},[_vm._v("获取vuex")])])
}
var staticRenderFns = []

export { render, staticRenderFns }